/* eslint-disable import/no-cycle */
import { nestCall, NestApiType } from '@/composables/nestApi';

export type AttributionKind = 'automation' | 'bulk';

export interface AttributionTouch {
  kind: AttributionKind;
  idSend: string;
  idWorkflow: string | null;
  idCampaign: number | null;
  idCampaignStep: string | null;
  scenarioName: string | null;
  channel: number | null;
  dateSend: string | null;
  dateLastOpen: string | null;
  dateLastClick: string | null;
  lagSeconds: number | null;
  isWinner: boolean;
  isTracked: boolean;
  rank: number;
  isEffectiveWinner?: boolean;
}

export interface SaleAttributionGroup {
  kind: AttributionKind;
  idStatsSell: string;
  idStatsSend: string;
  amount: number;
  amountWithoutTax: number;
  currency: string;
  dateCreation: string;
  touches: AttributionTouch[];
  crossChannelTouches: AttributionTouch[];
}

export interface SaleAttributionDetail {
  idShopOrder: string;
  groups: SaleAttributionGroup[];
}

interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: unknown;
}

export const getSaleAttributionDetail = async (
  idShopOrder: string | number,
): Promise<SaleAttributionDetail | null> => {
  const response = (await nestCall(
    'get',
    NestApiType.CLIENT_API,
    `/stats/sale-attribution-detail/${idShopOrder}`,
  )) as ApiResponse<SaleAttributionDetail>;

  if (!response || response.error || response.success === false) {
    return null;
  }
  return response.data ?? null;
};
